<template>
  <div class="app-exception">
    <div class="app-exception__img app-exception__img--500"></div>
    <h1>500</h1>
    <p>抱歉，服务器出错了</p>
  </div>

</template>
<script>
export default {
  name: 'ServerError'
}
</script>
